import { useAuth } from "../../hooks/useAuth";
import Logowhite from '../../Utils/img/ine_white.svg';
import './home.scss';

function ContentHome() {
    const { login } = useAuth();

    const accDashboard = (event) =>{
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        login({
            email: data.get("email")
        });
    };
    return(
        <>
            <div className="home">
                <div className="home__content">
                    <div className="home__content__right">
                        <div className="home__content__right--lg">
                            {/* <img className="home__content__right--ic" src={Logowhite} alt="INE Logo"></img> */}
                        </div>
                    </div>
                    <div className="home__content__left">
                        <h1 className="home__content__left--title">Contexto Nacional</h1>
                        {/* <span className="home__content__left-subtitle">DECEyEC</span> */}
                        <form onSubmit={accDashboard} className="home__content__form">
                            <input required autoFocus className="home__content__input" id="email" type="email" name="email" placeholder="Correo electronico"/>
                            <button type="submit" className="home__content__btn">INGRESAR</button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContentHome;